// frontend/src/services/socketClient.js
// Socket.IO client for /client namespace
import { io } from 'socket.io-client';

class SocketClient {
  constructor() {
    this.socket = null;
    this.listeners = {};
    this.connected = false;
  }

  connect() {
    if (this.socket && this.socket.connected) return this.socket;

    this.socket = io("/client", {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Client connected: ' + this.socket.id);
      this.connected = true;
      // Re-register all stored listeners onto the (possibly new) socket
      Object.keys(this.listeners).forEach(event => {
        const cbs = this.listeners[event];
        cbs.forEach(cb => {
          this.socket.off(event, cb);       // remove any stale registration
          this.socket.on(event, cb);        // re-attach fresh
        });
      });
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[Socket] Client disconnected: ' + reason);
      this.connected = false;
    });

    this.socket.on('connect_error', (err) => {
      console.warn('[Socket] Connection error:', err.message);
    });

    return this.socket;
  }

  joinCart(cartId) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('join-cart', { cartId });
    }
  }

  leaveCart(cartId) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('leave-cart', { cartId });
    }
  }

  requestSync(cartIds) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('reconnect:request-sync', { cartIds });
    }
  }

  on(event, callback) {
    if (!this.socket) return;
    this.socket.on(event, callback);
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);
  }

  off(event, callback) {
    if (!this.socket) return;
    if (callback) {
      this.socket.off(event, callback);
    } else {
      this.socket.off(event);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }
}

const socketClient = new SocketClient();
export default socketClient;
